export const FIELD_TYPE_INPUT_TEXT = { id: 1, name: 'Текст' };
export const FIELD_TYPE_INPUT_NUMBER = { id: 2, name: 'Число' };
export const FIELD_TYPE_INPUT_DATE = { id: 3, name: 'Дата' };
export const FIELD_TYPE_CHECKBOX = { id: 4, name: 'Флажок' };
export const FIELD_TYPE_SELECT = { id: 11, name: 'Выбор из множества' };
export const FIELD_TYPE_FILE = { id: 5, name: 'Файл' };
// export const FIELD_TYPE_RADIO = { id: 7, name: 'Радио' };
export const FIELD_TYPE_TEXTAREA = { id: 6, name: 'Текстовая область' };
export const FIELD_TYPE_SAMPLE_FILE = { id: 12, name: 'Образец файла' };
export const FIELD_TYPE_FILE_SET = { id: 7, name: 'Множество файлов' };
export const FIELD_TYPE_ADDRESS = { id: 8, name: 'Адрес' };
export const FIELD_TYPE_LABEL = { id: 9, name: 'Подпись' };
export const FIELD_TYPE_FIXED_TABLE = { id: 10, name: 'Таблица' };
export const FIELD_TYPE_DYNAMIC_TABLE = { id: 13, name: 'Динамическая Таблица' };
export const FIELD_TYPE_PICTURE = { id: 14, name: 'Изображение' };
export const FIELD_TYPE_PICTURE_GALLERY = { id: 15, name: 'Галерея изображений' };
export const FIELD_TYPE_VIDEO = { id: 16, name: 'Видео' };
export const FIELD_TYPE_GEOLOCATION = { id: 17, name: 'Местоположение' };
export const FIELD_TYPE_WYSIWYG = { id: 18, name: 'Текстовый редактор' };
export const FIELD_TYPE_TREE_SELECT = {
  id: 19,
  name: 'Выбор из множества элементов с древовидной структурой',
};
export const FIELD_TYPE_TREE = { id: 20, name: 'Древовидная структура' };
// export const FIELD_TYPE_SAMPLE_FILE = { id: 22, name: 'Пример файла для заполнения' };
export const FIELD_TYPE_SEPARATOR = { id: 21, name: 'Разделитель' };
export const FIELD_TYPE_TUPLE = { id: 22, name: 'Кортеж' };
export const FIELD_TYPE_OBJECT = { id: 23, name: 'Объект' };

export const FIELD_TYPES = {
  FIELD_TYPE_INPUT_TEXT,
  FIELD_TYPE_INPUT_NUMBER,
  FIELD_TYPE_INPUT_DATE,
  FIELD_TYPE_CHECKBOX,
  FIELD_TYPE_SELECT,
  FIELD_TYPE_FILE,
  // FIELD_TYPE_RADIO,
  FIELD_TYPE_TEXTAREA,
  FIELD_TYPE_SAMPLE_FILE,
  FIELD_TYPE_FILE_SET,
  FIELD_TYPE_ADDRESS,
  FIELD_TYPE_LABEL,
  FIELD_TYPE_FIXED_TABLE,
  FIELD_TYPE_DYNAMIC_TABLE,
  FIELD_TYPE_PICTURE,
  FIELD_TYPE_PICTURE_GALLERY,
  FIELD_TYPE_WYSIWYG,
  FIELD_TYPE_VIDEO,
  FIELD_TYPE_GEOLOCATION,
  FIELD_TYPE_TREE_SELECT,
  FIELD_TYPE_TREE,
  FIELD_TYPE_SEPARATOR,
  FIELD_TYPE_TUPLE,
  FIELD_TYPE_OBJECT,
};

/**
 * Тип дней для ограничения дат
 */
export enum DaysMode {
  workdays = 'workdays',
  all = 'all',
}

/**
 * Тип "направления" ограничения дат - до указанного количества дней от
 * текущей даты включительно, или после не включительно.
 */
export enum DateDirection {
  before = 'before',
  after = 'after',
}

export enum HandsontableCellType {
  catalogRecordAmount = 'catalog_record_amount',
  numeric = 'numeric',
  catalog = 'catalog',
  text = 'text',
}

export const HandsontableCellTypes = [
  { value: HandsontableCellType.numeric, label: 'Число' },
  { value: HandsontableCellType.text, label: 'Строка' },
  { value: HandsontableCellType.catalog, label: 'Значение каталога' },
  { value: HandsontableCellType.catalogRecordAmount, label: 'Число, с ограничениями из каталога' },
];
